// Las listas de casos no traen los textos largos (CAMPOS_VISTA en api/vistasCaso.ts). Al abrir un caso de la lista se
// piden aparte (CAMPOS_DETALLE) y se juntan aqui.
import type { Caso, NotaInterna, RawCaso } from '../api/casos';

export type DetalleCaso = Pick<RawCaso, 'id' | 'siguientePasoIA' | 'respuestaIA' | 'notasInternas'>;

// Las notas internas solo crecen (se agregan, nunca se borran): entre la lista (que puede traer la nota recien guardada
// al instante), el detalle y lo ultimo que se mostro, valen las mas completas. Asi una nota recien escrita no
// desaparece un momento mientras se refrescan la lista y el detalle por separado.
export function juntarDetalle(base: Caso, d: DetalleCaso, notasVistas: NotaInterna[] = []): Caso {
  const delDetalle = Array.isArray(d.notasInternas) ? d.notasInternas : [];
  const notas = [base.notas, delDetalle, notasVistas].reduce((a, b) => (b.length > a.length ? b : a));
  return { ...base, siguientePasoIA: d.siguientePasoIA ?? base.siguientePasoIA, respuestaIA: d.respuestaIA ?? base.respuestaIA, notas };
}
